import styled from 'styled-components';
import { palette } from 'styled-theme';

export const AppLayout = styled.main`
  display: grid;
  grid-auto-flow: row;
  min-height: 100vh;
  max-width: 3000px;
  margin: 0 auto;
  flex: 1;
  width: 100%;
  background-color: ${palette('background', 0)};
`;
